import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-configure-facebook-pages',
  templateUrl: './configure-facebook-pages.component.html',
  styleUrls: ['./configure-facebook-pages.component.scss']
})
export class ConfigureFacebookPagesComponent {
  formData = {
    appId: '',
    appSecret: '',
    pageToken: '',
    verifyToken: ''
  };

  constructor(private dialogRef: MatDialogRef<ConfigureFacebookPagesComponent>) {}

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    console.log('Saved Config:', this.formData);
    this.dialogRef.close(this.formData);
  }
}
